function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M0 23c1.77-5.15 7.3-5.23 8.62-5.54l.6-.27c1.76-1.89-.35-4.95-.53-5.21a2.73 2.73 0 0 1-.57-2.55c-.2-.68-.93-3.59.45-5.53.8-1.12 2.14-1.7 3.98-1.71 1.75-.43 3.1-.14 4.02.87 1.55 1.69 1.28 4.79.98 5.9.12.4.25 1.38-.51 2.93l-.44.84c-1.04 1.9-1.61 3.23-.2 4.43.5.16 6.53 2.52 7.6 5.84H0z"
});

var SvgAdult = function SvgAdult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adult.9fe31bec.svg";
export { ForwardRef as ReactComponent };